export const IS_MOCK_ENV = false;
export const enableMocking = async () => {};
